import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _deleteMemberReportsRequest = {};
var _deleteMemberReportsResponse = {};
var _listReportedMembersRequest = {};
var _listReportedMembersResponse = { reportedMembers: '_reportedMember' };
var _markMemberReportsAsReviewedRequest = {};
var _markMemberReportsAsReviewedResponse = {
    reportedMember: '_reportedMember',
};
var _memberReport = { createdDate: 'google.protobuf.Timestamp' };
var _queryMemberReportsRequest = {};
var _queryMemberReportsResponse = { memberReports: '_memberReport' };
var _queryReportedMembersRequest = {};
var _queryReportedMembersResponse = { reportedMembers: '_reportedMember' };
var _reportedMember = { lastReportDate: 'google.protobuf.Timestamp' };
var _reportMemberRequest = { memberReport: '_memberReport' };
var _reportMemberResponse = { memberReport: '_memberReport' };
function resolveComWixpressMembersMemberreportsMemberReportsUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/members/v1/member-reports',
                destPath: '/v1/member-reports',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/members-reports-api',
                destPath: '',
            },
        ],
        'members.wixapps.net': [
            {
                srcPath: '/v1/member-reports',
                destPath: '/v1/member-reports',
            },
        ],
        _: [
            {
                srcPath: '/members/v1/member-reports',
                destPath: '/v1/member-reports',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/members/v1/member-reports',
                destPath: '/v1/member-reports',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Reports member. */
export function reportMember(payload) {
    var _a = serializer(_reportMemberRequest, { _memberReport: _memberReport }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reportMemberResponse, {
        _memberReport: _memberReport,
    }).fromJSON;
    function __reportMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reportMember.fromReq = fromReq;
    return __reportMember;
}
/** Retrieves member reports. */
export function queryMemberReports(payload) {
    var _a = serializer(_queryMemberReportsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryMemberReportsResponse, {
        _memberReport: _memberReport,
    }).fromJSON;
    function __queryMemberReports(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryMemberReports.fromReq = fromReq;
    return __queryMemberReports;
}
/** Marks member reports as reviewed. */
export function markMemberReportsAsReviewed(payload) {
    var _a = serializer(_markMemberReportsAsReviewedRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_markMemberReportsAsReviewedResponse, { _reportedMember: _reportedMember }).fromJSON;
    function __markMemberReportsAsReviewed(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/members/{memberId}/mark-as-reviewed',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __markMemberReportsAsReviewed.fromReq = fromReq;
    return __markMemberReportsAsReviewed;
}
/** Retrieves list of reported members. */
export function listReportedMembers(payload) {
    var _a = serializer(_listReportedMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listReportedMembersResponse, {
        _reportedMember: _reportedMember,
    }).fromJSON;
    function __listReportedMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'GET',
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/members',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listReportedMembers.fromReq = fromReq;
    return __listReportedMembers;
}
/** Retrieves reported members. */
export function queryReportedMembers(payload) {
    var _a = serializer(_queryReportedMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryReportedMembersResponse, {
        _reportedMember: _reportedMember,
    }).fromJSON;
    function __queryReportedMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'POST',
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryReportedMembers.fromReq = fromReq;
    return __queryReportedMembers;
}
/** Deletes member reports. */
export function deleteMemberReports(payload) {
    var _a = serializer(_deleteMemberReportsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteMemberReportsResponse, {}).fromJSON;
    function __deleteMemberReports(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveComWixpressMembersMemberreportsMemberReportsUrl({
                protoPath: '/v1/member-reports/members/{memberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteMemberReports.fromReq = fromReq;
    return __deleteMemberReports;
}
//# sourceMappingURL=http.impl.js.map